<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <card card-body-classes="table-full-width px-3">
          <div slot="header">
            <h4 class="card-title f-20-mobile">
              Vendas do dia {{ data_inicio_cabecalho }} à
              {{ data_fim_cabecalho }}
            </h4>
          </div>
          <div class="row">
            <div class="col-12 col-sm-4 col-md-3 col-lg-2">
              <input
                type="date"
                class="form-control mx-2 mx-auto-mobile my-2-mobile"
                style="max-width: 220px"
                v-model="data_inicio"
              />
            </div>
            <div class="col-12 col-sm-4 col-md-3 col-lg-2">
              <input
                type="date"
                class="form-control mx-2 mx-auto-mobile my-2-mobile"
                style="max-width: 220px"
                v-model="data_fim"
              />
            </div>
            <div class="col-6 col-sm-4 col-md-5">
              <n-button
                type="primary"
                class="btn btn-round btn-wd btn-info mx-auto-mobile mb-2-mobile"
                v-on:click.native="filtrar"
                style="
                  height: 30px;
                  margin-left: 20px;
                  padding: 0;
                  margin-top: 0;
                "
                >Filtrar</n-button
              >
            </div>

            <div class="col-6 col-sm-4 col-md-3">
              <download-excel
                :fetch="fetchData"
                :title="
                  'Relatório de Apuração PIS/COFINS ' +
                  data_inicio_cabecalho +
                  ' até ' +
                  data_fim_cabecalho
                "
                name="Relatório de Apuração PIS/COFINS"
              >
                <n-button
                  type="primary"
                  class="
                    btn btn-round btn-wd btn-info
                    mx-auto-mobile
                    mb-2-mobile
                  "
                  style="
                    height: 30px;
                    margin-left: 20px;
                    padding: 0;
                    margin-top: 0;
                    float: right;
                  "
                  >Exportar Excel</n-button
                >
              </download-excel>
            </div>
            <div class="col-6 col-sm-4 col-md-3">
              <label>CST</label>
              <select
                name="select_cst"
                class="form-control"
                v-model="select_cst"
              >
                <option value="0" selected>Todos os registros</option>
                <option value="1">
                  01 - Operação Tributável com Alíquota Básica
                </option>
                <option value="2">
                  02 - Operação Tributável com Alíquota Diferenciada
                </option>
                <option value="3">
                  03 - Operação Tributável com Alíquota por Unidade de Medida de
                  Produto
                </option>
                <option value="4">
                  04 - Operação Tributável Monofásica – Revenda a Alíquota Zero
                </option>
                <option value="5">
                  05 - Operação Tributável por Substituição Tributária
                </option>
                <option value="6">
                  06 - Operação Tributável a Alíquota Zero
                </option>
                <option value="7">
                  07 - Operação Isenta das Contribuições
                </option>
                <option value="8">
                  08 - Operação sem Incidência das Contribuições
                </option>
                <option value="9">
                  09 - Operação com Suspensão das Contribuições
                </option>
                <option value="49">49 - Outras Operações de Saída</option>
              </select>
            </div>
          </div>
          <br />
          <br />
          <table
            class="
              display
              responsive
              nowrap
              table table-hover table-striped table-bordered
              hidden-mobile
            "
          >
            <thead>
              <tr>
                <th class="text-center">Cod Produto</th>
                <th class="text-center">Descrição Prod</th>
                <th class="text-center">PIS</th>
                <th class="text-center">COFINS</th>
                <th class="text-center">Quantidade</th>
                <th class="text-center">Vr Total Produto</th>
                <th class="text-center">Vr PIS</th>
                <th class="text-center">Vr COFINS</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="venda of vendas">
                <td class="text-center">{{ venda.codigo }}</td>
                <td class="text-center">{{ venda.descricao }}</td>
                <td class="text-center">{{ venda.pis_cst }}</td>
                <td class="text-center">{{ venda.cofins_cst }}</td>
                <td class="text-center">{{ venda.quantidade }}</td>
                <td class="text-center">
                  {{ venda.valor_total | currencyBrl(true) }}
                </td>
                <td class="text-center">{{ venda.valor_pis }}</td>
                <td class="text-center">{{ venda.valor_cofins }}</td>
              </tr>
              <tr v-if="!vendas || !vendas.length">
                <td class="text-center" colspan="6">
                  Nenhum resultado encontrado
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td>Totais</td>
                <td></td>
                <td></td>
                <td class="text-center"></td>
                <td class="text-center">{{ quantidadeProduto }}</td>
                <td class="text-center">
                  {{ valorTotalProduto | currencyBrl(true) }}
                </td>
                <td class="text-center">
                  {{ valorTotalPIS | currencyBrl(true) }}
                </td>
                <td class="text-center">
                  {{ valorTotalCOFINS | currencyBrl(true) }}
                </td>
              </tr>
            </tfoot>
          </table>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {
  Card,
  AnimatedNumber,
  Progress as NProgress,
  LineChart,
} from "src/components";
import { setInterval } from "timers";
import { Table, TableColumn } from "element-ui";
import HeaderChart from "../Dashboard/HeaderChart";
import moment from "moment";
import GlobalFunctions from "../../../globalFunctions.js";
import FiscalService from "@/services/FiscalService.js";

export default {
  components: {
    Card,
    AnimatedNumber,
    LineChart,
    NProgress,
    HeaderChart,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    moment,
  },
  data() {
    return {
      data_inicio: moment().format("YYYY-MM-DD"),
      data_fim: moment().format("YYYY-MM-DD"),
      data_fim_cabecalho: moment().format("DD/MM/YYYY"),
      data_inicio_cabecalho: moment().format("DD/MM/YYYY"),
      select_cst: 0,
      mobile: GlobalFunctions.isMobile(),
      modulo_mfe:localStorage.getItem('config_modulo_mfe') == "true" ? true : false,
      vendas: [],
      quantidadeProduto: 0,
      valorTotalProduto: 0,
      valorTotalPIS: 0,
      valorTotalCOFINS: 0,
    };
  },
  methods: {
    async fetchData() {
      let params = `?data_inicio=${this.data_inicio}&data_fim=${this.data_fim}&select_cst=${this.select_cst}`
      if(this.modulo_mfe){
        params += "&config_cfe="+this.modulo_mfe;
      }
      let response = await FiscalService.loadPISCOFINS(
        params
      );
      let dados = [];

      for (let item of response.data.relatorio) {
        let tmp = {};
        tmp["Cod Produto"] = item.codigo;
        tmp["Descrição do Prod"] = item.descricao;
        tmp["Tributação PIS"] = item.pis_cst;
        tmp["Tributação Cofins"] = item.cofins_cst;
        tmp["NCM"] = item.ncm_sh;
        tmp["Qtd Prod"] = item.quantidade;
        tmp["Unidade"] = item.unidade;
        tmp["CFOP"] = item.cfop;
        tmp["Vr Total Produto"] = this.$options.filters.currencyBrl(item.valor_total);
        tmp["Vr Total Pis"] = this.$options.filters.currencyBrl(item.valor_pis);
        tmp["Vr Total Cofins"] = this.$options.filters.currencyBrl(item.valor_cofins);

        dados.push(tmp);
      }

      dados.push({
        "Cod Produto": "Totais",
        "Qtd Prod": this.quantidadeProduto,
        "Vr Total Produto": this.$options.filters.currencyBrl(this.valorTotalProduto),
        "Vr Total Pis": this.$options.filters.currencyBrl(this.valorTotalPIS),
        "Vr Total Cofins": this.$options.filters.currencyBrl(this.valorTotalCOFINS),
      });
      return dados;
    },
    changePage(page) {
      this.current_page = page;
      this.loadVendas();
    },

    filtrar() {
      this.data_fim_cabecalho = moment(this.data_fim).format("DD/MM/YYYY");
      this.data_inicio_cabecalho = moment(this.data_inicio).format(
        "DD/MM/YYYY"
      );
      this.loadVendas();
    },

    loadVendas() {
      let loader = this.$loading.show();
      let params = `?data_inicio=${this.data_inicio}&data_fim=${this.data_fim}&select_cst=${this.select_cst}`
      if(this.modulo_mfe){
        params += "&config_cfe="+this.modulo_mfe;
      }
      FiscalService.loadPISCOFINS(
        params
      )
        .then((res) => {
          this.vendas = res.data.relatorio;
          this.quantidadeProduto = res.data.quantidadeProduto;
          this.valorTotalProduto = res.data.valorTotalProduto;
          this.valorTotalPIS = res.data.valorTotalPIS;
          this.valorTotalCOFINS = res.data.valorTotalCOFINS;
          loader.hide();
        })
        .catch((err) => {
          loader.hide();
        });
    },
  },
  mounted() {
    this.loadVendas();
  },
};
</script>
